var QJ, rreturn, rtrim;

QJ = function(selector) {
  if (QJ.isDOMElement(selector)) {
    return selector;
  }
  return document.querySelectorAll(selector);
};

QJ.isDOMElement = function(el) {
  return el && (el.nodeName != null);
};

rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

QJ.trim = function(text) {
  if (text === null) {
    return "";
  } else {
    return (text + "").replace(rtrim, "");
  }
};

rreturn = /\r/g;

QJ.val = function(el, val) {
  var ret;
  if (arguments.length > 1) {
    return el.value = val;
  } else {
    ret = el.value;
    if (typeof ret === "string") {
      return ret.replace(rreturn, "");
    } else {
      if (ret === null) {
        return "";
      } else {
        return ret;
      }
    }
  }
};

QJ.preventDefault = function(eventObject) {
  if (typeof eventObject.preventDefault === "function") {
    eventObject.preventDefault();
    return;
  }
  eventObject.returnValue = false;
  return false;
};

QJ.normalizeEvent = function(e) {
  var original;
  original = e;
  e = {
    which: original.which != null ? original.which : void 0,
    target: original.target || original.srcElement,
    preventDefault: function() {
      return QJ.preventDefault(original);
    },
    originalEvent: original,
    data: original.data || original.detail
  };
  if (e.which == null) {
    e.which = original.charCode != null ? original.charCode : original.keyCode;
  }
  return e;
};

QJ.on = function(element, eventName, callback) {
  var el, i, j, len, len1, multEventName, originalCallback, ref;
  if (element.length) {
    for (i = 0, len = element.length; i < len; i++) {
      el = element[i];
      QJ.on(el, eventName, callback);
    }
    return;
  }
  if (eventName.match(" ")) {
    ref = eventName.split(" ");
    for (j = 0, len1 = ref.length; j < len1; j++) {
      multEventName = ref[j];
      QJ.on(element, multEventName, callback);
    }
    return;
  }
  originalCallback = callback;
  callback = function(e) {
    e = QJ.normalizeEvent(e);
    return originalCallback(e);
  };
  if (element.addEventListener) {
    return element.addEventListener(eventName, callback, false);
  }
  if (element.attachEvent) {
    eventName = "on" + eventName;
    return element.attachEvent(eventName, callback);
  }
  element['on' + eventName] = callback;
};

QJ.addClass = function(el, className) {
  var e;
  if (el.length) {
    return (function() {
      var i, len, results;
      results = [];
      for (i = 0, len = el.length; i < len; i++) {
        e = el[i];
        results.push(QJ.addClass(e, className));
      }
      return results;
    })();
  }
  if (el.classList) {
    return el.classList.add(className);
  } else {
    return el.className += ' ' + className;
  }
};

QJ.hasClass = function(el, className) {
  var e, hasClass, i, len;
  if (el.length) {
    hasClass = true;
    for (i = 0, len = el.length; i < len; i++) {
      e = el[i];
      hasClass = hasClass && QJ.hasClass(e, className);
    }
    return hasClass;
  }
  if (el.classList) {
    return el.classList.contains(className);
  } else {
    return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
  }
};

QJ.removeClass = function(el, className) {
  var cls, e, i, len, ref, results;
  if (el.length) {
    return (function() {
      var i, len, results;
      results = [];
      for (i = 0, len = el.length; i < len; i++) {
        e = el[i];
        results.push(QJ.removeClass(e, className));
      }
      return results;
    })();
  }
  if (el.classList) {
    ref = className.split(' ');
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      cls = ref[i];
      results.push(el.classList.remove(cls));
    }
    return results;
  } else {
    return el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
  }
};

QJ.toggleClass = function(el, className, bool) {
  var e;
  if (el.length) {
    return (function() {
      var i, len, results;
      results = [];
      for (i = 0, len = el.length; i < len; i++) {
        e = el[i];
        results.push(QJ.toggleClass(e, className, bool));
      }
      return results;
    })();
  }
  if (bool) {
    if (!QJ.hasClass(el, className)) {
      return QJ.addClass(el, className);
    }
  } else {
    return QJ.removeClass(el, className);
  }
};

QJ.append = function(el, toAppend) {
  var e;
  if (el.length) {
    return (function() {
      var i, len, results;
      results = [];
      for (i = 0, len = el.length; i < len; i++) {
        e = el[i];
        results.push(QJ.append(e, toAppend));
      }
      return results;
    })();
  }
  return el.insertAdjacentHTML('beforeend', toAppend);
};

QJ.find = function(el, selector) {
  if (el instanceof NodeList || el instanceof Array) {
    el = el[0];
  }
  return el.querySelectorAll(selector);
};

QJ.trigger = function(el, name, data) {
  var e, ev;
  try {
    ev = new CustomEvent(name, {
      detail: data
    });
  } catch (error) {
    e = error;
    ev = document.createEvent('CustomEvent');
    if (ev.initCustomEvent) {
      ev.initCustomEvent(name, true, true, data);
    } else {
      ev.initEvent(name, true, true, data);
    }
  }
  return el.dispatchEvent(ev);
};

module.exports = QJ;

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
